var QJ, rreturn, rtrim;

QJ = function(selector) {
  if (QJ.isDOMElement(selector)) {
    return selector;
  }
  return document.querySelectorAll(selector);
};

QJ.isDOMElement = function(el) {
  return el && (el.nodeName != null);
};

rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

QJ.trim = function(text) {
  if (text === null) {
    return "";
  } else {
    return (text + "").replace(rtrim, "");
  }
};

rreturn = /\r/g;

QJ.val = function(el, val) {
  var ret;
  if (arguments.length > 1) {
    return el.value = val;
  } else {
    ret = el.value;
    if (typeof ret === "string") {
      return ret.replace(rreturn, "");
    } else {
      if (ret === null) {
        return "";
      } else {
        return ret;
      }
    }
  }
};

QJ.preventDefault = function(eventObject) {
  if (typeof eventObject.preventDefault === "function") {
    eventObject.preventDefault();
    return;
  }
  eventObject.returnValue = false;
  return false;
};

QJ.normalizeEvent = function(e) {
  var original;
  original = e;
  e = {
    which: original.which != null ? original.which : void 0,
    target: original.target || original.srcElement,
    preventDefault: function() {
      return QJ.preventDefault(original);
    },
    originalEvent: original,
    data: original.data || original.detail
  };
  if (e.which == null) {
    e.which = original.charCode != null ? original.charCode : original.keyCode;
  }
  return e;
};

QJ.on = function(element, eventName, callback) {
  var el, i, j, len, len1, multEventName, originalCallback, ref;
  if (element.length) {
    for (i = 0, len = element.length; i < len; i++) {
      el = element[i];
      QJ.on(el, eventName, callback);
    }
    return;
  }
  if (eventName.match(" ")) {
    ref = eventName.split(" ");
    for (j = 0, len1 = ref.length; j < len1; j++) {
      multEventName = ref[j];
      QJ.on(element, multEventName, callback);
    }
    return;
  }
  originalCallback = callback;
  callback = function(e) {
    e = QJ.normalizeEvent(e);
    return originalCallback(e);
  };
  if (element.addEventListener) {
    return element.addEventListener(eventName, callback, false);
  }
  if (element.attachEvent) {
    eventName = "on" + eventName;
    return element.attachEvent(eventName, callback);
  }
  element['on' + eventName] = callback;
};

QJ.addClass = function(el, className) {
  var e;
  if (el.length) {
    return (function() {
      var i, len, results;
      results = [];
      for (i = 0, len = el.length; i < len; i++) {
        e = el[i];
        results.push(QJ.addClass(e, className));
      }
      return results;
    })();
  }
  if (el.classList) {
    return el.classList.add(className);
  } else {
    return el.className += ' ' + className;
  }
};

QJ.hasClass = function(el, className) {
  var e, hasClass, i, len;
  if (el.length) {
    hasClass = true;
    for (i = 0, len = el.length; i < len; i++) {
      e = el[i];
      hasClass = hasClass && QJ.hasClass(e, className);
    }
    return hasClass;
  }
  if (el.classList) {
    return el.classList.contains(className);
  } else {
    return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
  }
};

QJ.removeClass = function(el, className) {
  var cls, e, i, len, ref, results;
  if (el.length) {
    return (function() {
      var i, len, results;
      results = [];
      for (i = 0, len = el.length; i < len; i++) {
        e = el[i];
        results.push(QJ.removeClass(e, className));
      }
      return results;
    })();
  }
  if (el.classList) {
    ref = className.split(' ');
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      cls = ref[i];
      results.push(el.classList.remove(cls));
    }
    return results;
  } else {
    return el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
  }
};

QJ.toggleClass = function(el, className, bool) {
  var e;
  if (el.length) {
    return (function() {
      var i, len, results;
      results = [];
      for (i = 0, len = el.length; i < len; i++) {
        e = el[i];
        results.push(QJ.toggleClass(e, className, bool));
      }
      return results;
    })();
  }
  if (bool) {
    if (!QJ.hasClass(el, className)) {
      return QJ.addClass(el, className);
    }
  } else {
    return QJ.removeClass(el, className);
  }
};

QJ.append = function(el, toAppend) {
  var e;
  if (el.length) {
    return (function() {
      var i, len, results;
      results = [];
      for (i = 0, len = el.length; i < len; i++) {
        e = el[i];
        results.push(QJ.append(e, toAppend));
      }
      return results;
    })();
  }
  return el.insertAdjacentHTML('beforeend', toAppend);
};

QJ.find = function(el, selector) {
  if (el instanceof NodeList || el instanceof Array) {
    el = el[0];
  }
  return el.querySelectorAll(selector);
};

QJ.trigger = function(el, name, data) {
  var e, ev;
  try {
    ev = new CustomEvent(name, {
      detail: data
    });
  } catch (error) {
    e = error;
    ev = document.createEvent('CustomEvent');
    if (ev.initCustomEvent) {
      ev.initCustomEvent(name, true, true, data);
    } else {
      ev.initEvent(name, true, true, data);
    }
  }
  return el.dispatchEvent(ev);
};

module.exports = QJ;

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
